import React, { useState, useReducer, useCallback, useEffect, useRef } from 'react';
import { Link, useParams } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import { useSelector } from 'react-redux';
import moment from 'moment';

import "react-datepicker/dist/react-datepicker.css";

import { logsService } from '../../Services';

import Loader from '../Common/Loader';
import Modal from '../Common/Modal';

import {ReactComponent as Loading} from '../../images/icons/General/loading-01.svg';
import {ReactComponent as Copy} from '../../images/icons/General/copy-01.svg';
import {ReactComponent as Help} from '../../images/icons/General/help-circle.svg';
import {ReactComponent as Info} from '../../images/icons/General/info-circle.svg';

const dataReducer = (state, event) => {
    if (event.action === 'clear')
        return {};
    else 
        return {
            ...state,
            [event.key]: event.value
        };
};

export const Log = () => {
    const params = useParams();
    const [info, setInfo] = useState({});
    const [data, setData] = useReducer(dataReducer, {});
    const [loading, setLoading] = useState(false);
    const [copyLoading, setCopyLoading] = useState(false);
    const [pageLoading, setPageLoading] = useState(false);
    const [errors, setErrors] = useState([]);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [location, setLocation] = useState({});
    const [decompression, setDecompression] = useState({});
    const [gear, setGear] = useState({});
    const [gasMixture, setGasMixture] = useState({});
    const [surfaceCondition, setSurfaceCondition] = useState({});
    const [underwaterCondition, setUnderwaterCondition] = useState({});
    const [taskValue, setTaskValue] = useState([]);
    const [presentationProblemsValue, setPresentationProblemsValue] = useState([]);
    const [enviromentValue, setEnviromentValue] = useState([]);
    const [existing, setExisting] = useState(null);
    const [classification, setClassification] = useState(null);
    const [aggressionHelp, setAggressionHelp] = useState(null);
    const [defaultGear, setDefaultGear] = useState(null);

    const local = useSelector((state) => state.org.remember);
    const orgId = useSelector((state) => state.org.id);
    const is24h = useSelector((state) => state[local ? 'localUser' : 'user'].is24h);
    const modules = useSelector((state) => state.org.modules);

    const locationRef = useRef(null);
    const decompressionRef = useRef(null);

    const today = new Date();
    today.setDate(today.getDate() + 1);

    const minTime = new Date();
    minTime.setHours(0);
    minTime.setMinutes(0);

    const maxTime = new Date();
    maxTime.setHours(23);
    maxTime.setMinutes(59);

    const enviroments = ['Required Decompression', 'Overhead Environment', 'Blue Water', 'Ice/Polar', 'Saturation Diving', 'Aquarium Diving'];

    const feed = {
        0: [
            {
                value: null,
                label: "not fed by me"
            },
            {
                value: 0,
                label: "0% of the population ate"
            },
            {
                value: 10,
                label: "10% of the population ate"
            },
            {
                value: 20,
                label: "20% of the population ate"
            },
            {
                value: 30,
                label: "30% of the population ate"
            },
            {
                value: 40,
                label: "40% of the population ate"
            },
            {
                value: 50,
                label: "50% of the population ate"
            },
            {
                value: 60,
                label: "60% of the population ate"
            },
            {   
                value: 70,  
                label: "70% of the population ate"
            },
            {   
                value: 80,  
                label: "80% of the population ate"
            },
            {   
                value: 90,  
                label: "90% of the population ate"
            },
            {   
                value: 100,  
                label: "100% of the population ate"
            }
        ],
        1: [
            {
                value: null,
                label: "not fed by me"
            },
            {   
                value: 0,
                label: "Ate 0% of food"
            },
            {   
                value: 10,
                label: "Ate 10% of food"
            },
            {   
                value: 20,
                label: "Ate 20% of food"
            },
            {   
                value: 30,
                label: "Ate 30% of food"
            },
            {   
                value: 40,
                label: "Ate 40% of food"
            },
            {   
                value: 50,
                label: "Ate 50% of food"
            },
            {   
                value: 60,
                label: "Ate 60% of food"
            },
            {   
                value: 70,
                label: "Ate 70% of food"
            },
            {   
                value: 80,
                label: "Ate 80% of food"
            },
            {   
                value: 90,
                label: "Ate 90% of food"
            },
            {   
                value: 100,
                label: "Ate 100% of food"
            }
        ],
        2: [
            {
                value: null,
                label: "not fed by me"
            },
            {
                value: 0,
                label: "Ate 0 pieces of food"
            },
            {
                value: 10,
                label: "Ate 1 pieces of food"
            },
            {
                value: 20,
                label: "Ate 2 pieces of food"
            },
            {
                value: 30,
                label: "Ate 3 pieces of food"
            },
            {
                value: 40,
                label: "Ate 4 pieces of food"
            },
            {
                value: 50,
                label: "Ate 5 pieces of food"
            },
            {
                value: 60,
                label: "Ate 6 pieces of food"
            },
            {
                value: 70,
                label: "Ate 7 pieces of food"
            },
            {
                value: 80,
                label: "Ate 8 pieces of food"
            },
            {
                value: 90,
                label: "Ate 9 pieces of food"
            },
            {
                value: 100,
                label: "Ate 10+ pieces of food"
            },
        ]
    }

    const egagementLevels = [
        {
            value: null,
            label: "not observed by me"
        },
        {
            value: 0,
            label: "0 - None"
        },
        {
            value: 1,
            label: "1 - Poor"
        },
        {
            value: 2,
            label: "2 - Fair"
        },
        {
            value: 3,
            label: "3 - Good"
        },
        {
            value: 4,
            label: "4 - Great"
        },
        {
            value: 5,
            label: "5 - Excellent"
        }
    ]

    const customStyles = {
        container: (provided, state) => ({
            ...provided,
            flex: '1',
            height: '42px'
          }),
        control: (provided, state) => ({
          ...provided,
          border: '1px solid #D0D5DD',
          '&:hover': {
            boxShadow: '0 0 1px #5D3FC5'
          }
        }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    }

    const clearData = () => {
        setLocation({}); 
        setDecompression({}); 
        setGear(defaultGear || {});
        setGasMixture({});
        setSurfaceCondition({}); 
        setUnderwaterCondition({});
        setTaskValue([]); 
        setPresentationProblemsValue([]); 
        setEnviromentValue([]);
        setExisting(null);
        setError(null);
        setData({
            action: 'clear'
        });
        setData({
            key: 'gear',
            value: '1'
        });
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        
        setError('');
        setErrors([]);
        setSuccess(false);
        setLoading(true);

        if (params.diveId)
            data.id = params.diveId;

        if (params.userId)
            data.userId = params.userId;

        let message = '';

        if (parseInt(data.totalTime) < 1)
            message = 'Your dive time must be at least 1 minute';

        if (!data.date || !data.startTime || !data.totalTime || 
                !data.location || !data.diveDepth || !data.decompressionPlanning ||
                !data.gear || !data.gasMixture || !data.classificationId) {
            message = 'Please, enter required fields';

            ['date', 'startTime', 'totalTime', 'location', 'diveDepth', 'decompressionPlanning', 'gear', 'gasMixture', 'classificationId'].forEach((field) => { 
                if (!data[field]) {
                    setErrors(prev => [...prev, field]);
                }
            });
        }

        if (location?.SpecificLocation && !data.specificLocation) {
            message = 'Please, enter specific location';
            setErrors(prev => [...prev, 'specificLocation']);
        }

        if (data.CommProblemsSwitcher && ((!data.presentationProblems || data.presentationProblems.length === 0) && !data.CommProblems)) {
            message = 'Please, specify problems during presentation';
            setErrors(prev => [...prev, 'presentationProblems']);
        }

        if (data.date && today.toDateString() === data.date.toDateString() && data.startTime > new Date()) {
            message = 'Who do you think you are, Nostradamus? The date and time must be in the past';
            setErrors(prev => [...prev, 'startTime']);
        }

        if (!message) {
            const sendData = {
                ...data,
                date: data.date instanceof Date ? moment(data.date).format('YYYY-MM-DD') : data.date,
                startTime: data.startTime instanceof Date ? moment(data.startTime).format('HH:mm') : data.startTime
            };
            const res = await (params.diveId ? logsService.edit(sendData) : logsService.add(sendData));

            if (res.res === 'OK') {
                if (!params.diveId) {
                    clearData();
                    setInfo({
                        ...info,
                        divesNumber: info.divesNumber + 1
                    })
                }
                setSuccess(true);
            } else {
                setError(res.error);
                setExisting(res.existing);
            }
        } else {
            setError(message);
        }
        setLoading(false);
    };

    const changeValue = (key, value) => {
        setData({
            key: key,
            value: value,
        }); 

        errors && setErrors(prev => prev.filter(item => item !== key));

        if (key === 'CommProblemsSwitcher' && !value) {
            setData({
                key: 'presentationProblems',
                value: [],
            }); 
            setPresentationProblemsValue([]);
            setData({
                key: 'CommProblems',
                value: '',
            });
        }
    }

    const changeSelectValue = (name, value, selectSetVar) => {
        selectSetVar(value);
        setData({
            key: name,
            value: value.value,
        }); 

        errors && setErrors(prev => prev.filter(item => item !== name));

        if (name === 'location') {
            setData({
                key: 'diveDepth',
                value: value.Depth || 0,
            }); 

            if (value.Depth)
                setErrors(prev => prev.filter(item => item !== 'diveDepth'));

            if (value.decompressionPlanning) {
                setDecompression(info.decompression.filter(item => item.value === value.decompressionPlanning));
                setData({
                    key: 'decompressionPlanning',
                    value: value.decompressionPlanning,
                });
            }

            if (value.gear) {
                setGear(info.gears.filter(item => item.value === value.gear));
                setData({
                    key: 'gear',
                    value: value.gear,
                });
            }

            if (value.gasMixture) {
                setGasMixture(info.gasMixtures.filter(item => item.value === value.gasMixture));
                setData({
                    key: 'gasMixture',
                    value: value.gasMixture,
                });
            }

            if (value.classification) {
                setData({
                    key: 'classificationId',
                    value: value.classification,
                });
            }
        }
    }

    const changeFeedValue = (value, speciesId) => {
        setData({
            key: 'species',
            value: {
                ...data.species,
                [speciesId]: {
                    ...data.species?.[speciesId],
                    PercentFed: value.value,
                },
            },
        });
    }

    const changeEngagementValue = (value, speciesId) => {
        setData({
            key: 'species',
            value: {
                ...data.species,
                [speciesId]: {
                    ...data.species?.[speciesId],
                    Aggression: value.value,
                },
            },
        });
    }

    const changeCheckboxValue = (key, value, cbVar, cbSetVar) => {
        if (cbVar.indexOf(value) > -1) 
            cbVar.splice(cbVar.indexOf(value), 1)
        else 
            cbVar.push(value);
        
        cbSetVar(cbVar);
        setData({
            key: key,
            value: cbVar,
        }); 

        errors && setErrors(prev => prev.filter(item => item !== key));
    }

    const isTaskInList = (taskName, taskIds) => {
        return info.tasks ? Object.values(info.tasks).some(
            (task) => task.Task === taskName && taskIds.includes(task.TaskID.toString())
        ) : false;
    }

    const copyLastDive = async () => {
        setCopyLoading(true);

        const resData = await logsService.editInfo(-1, params.userId);
        Object.keys(resData.dive).forEach((key) => {
            switch (key) {  
                case 'date':
                case 'startTime':
                    resData.dive[key] = new Date(resData.dive[key].date);
                break;

                case 'location':
                    setLocation(info.locations ? info.locations.filter(item => item.value === resData.dive[key]) : '');
                break;
                
                case 'decompressionPlanning':
                    setDecompression(info.decompression.filter(item => item.value === resData.dive[key]));
                break;

                case 'gear':
                    setGear(info.gears.filter(item => item.value === resData.dive[key]));
                break;

                case 'gasMixture':
                    setGasMixture(info.gasMixtures.filter(item => item.value === resData.dive[key]));
                break;

                case 'surfaceCondition':
                    setSurfaceCondition(info.surfaceConditions.filter(item => item.value === resData.dive[key]));
                break;

                case 'underwaterCondition':
                    setUnderwaterCondition(info.underwaterConditions.filter(item => item.value === resData.dive[key]));
                break;

                case 'tasks':
                    setTaskValue(resData.dive[key]);
                break;

                case 'presentationProblems':
                    setPresentationProblemsValue(resData.dive[key]);
                break;

                case 'enviroments':
                    setEnviromentValue(resData.dive[key]);
                break;

                case 'species':
                    if (resData.dive.species && resData.dive.activeSpecies) {
                        resData.dive[key] = Object.fromEntries(
                            Object.entries(resData.dive[key] || {}).filter(([id, item]) => resData.dive.activeSpecies.map(Number).includes(Number(item.SpeciesID)))
                        );
                    }

                    console.log(resData.dive.activeSpecies, resData.dive[key])
                break;

                default:
            }   

            setData({
                key: key,
                value: resData.dive[key]
            });

            setData({
                key: 'CommProblemsSwitcher',
                value: (resData.dive['CommProblems'] && resData.dive['CommProblems'].length > 0) || (resData.dive['presentationProblems'] && resData.dive['presentationProblems'].length > 0) ? true : false
            });
        });

        setCopyLoading(false);
    }

    const fetchData = useCallback(async (last) => {
        setPageLoading(true);
        const surfaceConditions = [
            {value: 1, label: 'Calm'},
            {value: 2, label: 'Moderate'},
            {value: 3, label: 'Rough'}
        ];

        const underwaterConditions = [
            {value: 1, label: 'Good'},
            {value: 2, label: 'Moderate'},
            {value: 3, label: 'Poor'}
        ];


        const res = await logsService.addInfo(params.userId || 0);
        setInfo({
            ...res,
            surfaceConditions: surfaceConditions,
            underwaterConditions: underwaterConditions
        });
        if (res.error)
            setError(res.error);

            if (params.diveId) {
                const resData = await logsService.editInfo(params.diveId);
                Object.keys(resData.dive).forEach((key) => {
                    switch (key) {  
                        case 'date':
                        case 'startTime':
                            resData.dive[key] = new Date(resData.dive[key].date);
                        break;
    
                        case 'location':
                            setLocation(res.locations ? res.locations.filter(item => item.value === resData.dive[key]) : '');
                        break;
                        
                        case 'decompressionPlanning':
                            setDecompression(res.decompression.filter(item => item.value === resData.dive[key]));
                        break;
    
                        case 'gear':
                            setGear(res.gears.filter(item => item.value === resData.dive[key]));
                        break;
    
                        case 'gasMixture':
                            setGasMixture(res.gasMixtures.filter(item => item.value === resData.dive[key]));
                        break;

                        case 'surfaceCondition':
                            setSurfaceCondition(surfaceConditions.filter(item => item.value === resData.dive[key]));
                        break;

                        case 'underwaterCondition':
                            setUnderwaterCondition(underwaterConditions.filter(item => item.value === resData.dive[key]));
                        break;
    
                        case 'tasks':
                            setTaskValue(resData.dive[key]);
                        break;

                        case 'presentationProblems':
                            setPresentationProblemsValue(resData.dive[key]);
                        break;
    
                        case 'enviroments':
                            setEnviromentValue(resData.dive[key]);
                        break;
    
                        default:
                    }   
    
                    setData({
                        key: key,
                        value: resData.dive[key]
                    });
                });

                setData({
                    key: 'CommProblemsSwitcher',
                    value: (resData.dive['CommProblems'] && resData.dive['CommProblems'].length > 0) || (resData.dive['presentationProblems'] && resData.dive['presentationProblems'].length > 0) ? true : false
                });
            } else {
                if (res.gear) {
                    const value = res.gears.filter(item => item.value === res.gear);
                    setGear(value);
                    setDefaultGear(value);
                
                    setData({
                        key: 'gear',
                        value: res.gear
                    });
                }
            }
        

        setPageLoading(false);
      }, [params]);
      
    useEffect(() => {
        clearData();
        fetchData();
    }, [fetchData]);

    console.log(data)
    
    return (
        <>
            {pageLoading ? <Loader /> : 
                <>
                    <h1>{params.diveId ? 'Edit dive' : 'Log new dives'}</h1>
                    {(params.diveId || !info.divesNumber) ? '' : <div>
                        <button type="button" className="default" onClick={copyLastDive} disabled={copyLoading}>{copyLoading ? <Loading className="btn-loader" /> : <Copy />}Copy last dive values</button>
                    </div>}
                    <form onSubmit={handleSubmit} className={error ? 'required' : ''} noValidate>
                        <div className="form-column">
                            <label>Diver</label>
                            <div>
                                {info.userName} <br />
                                (<Link to={params.userId ? `/configuration/users/${params.userId}/dives/` : `/logs/history`}>{info.divesNumber} logged dive{info.divesNumber === 1 ? '' : 's'}, {info.divesNumberYear} of which in the last 12 months</Link>)
                            </div>
                        </div>
                        <div className="form-column">
                            <label>Surface interval since the prior dive<span className="hint"><Help /><span>e.g. “&gt;24 hrs”, “HH:MM ”</span></span><span>(Optional)</span></label>
                            <input type="text" name="surfaceInterval" value={data.surfaceInterval || ''} onChange={(e) => changeValue(e.target.name, e.target.value)} maxLength="10" />
                        </div>
                        <div className="form-column mb-32">
                            <label>Dive date</label>
                            <DatePicker 
                                name="date" 
                                selected={data.date} 
                                maxDate={today} 
                                onChange={(value) => changeValue('date', value)}  
                                placeholderText="Select date" 
                                className={`required ${errors.indexOf('date') > -1 ? 'error' : ''}`}
                                autoComplete="off"
                                required={true}
                                isClearable
                             />
                        </div>
                        <div className="form-column">
                            <label>Dive start time<span>Please log only the dives that already happened</span></label>
                            <DatePicker 
                                name="startTime" 
                                onChange={(value) => changeValue('startTime', value)} 
                                minTime={minTime}
                                maxTime={(data.date && today.toDateString() === data.date.toDateString()) ? new Date() : maxTime} 
                                selected={data.startTime || ''} 
                                showTimeSelect
                                showTimeSelectOnly
                                timeIntervals={15}
                                timeFormat={is24h > 0 ? 'HH:mm' : 'hh:mm a'} 
                                dateFormat={is24h > 0 ? 'HH:mm' : 'hh:mm a'} 
                                isClearable
                                autoComplete="off"
                                className={`required ${errors.indexOf('startTime') > -1 ? 'error' : ''}`}
                                required={true}
                            />
                        </div>
                        <div className="form-column">
                            <label>Total time of dive<span>Enter minutes, surface to surface</span></label>
                            <input type="number"
                                step="1"
                                name="totalTime"
                                value={data.totalTime || ''}
                                maxLength="3"
                                onChange={(e) => changeValue(e.target.name, e.target.value)}
                                onKeyUp={(e) => {
                                    if (e.target.value.length > 2) locationRef.current.focus();
                                }}
                                className={`required ${errors.indexOf('totalTime') > -1 ? 'error' : ''}`}
                                required={true} />
                        </div>
                        <div className="form-column">
                            <label>Location or project</label>
                            <Select ref={locationRef} className={`select required ${errors.indexOf('location') > -1 ? 'error' : ''}`} required
                                options={info.locations} 
                                onChange={(value) => changeSelectValue('location', value, setLocation)} 
                                styles={customStyles}  
                                value={location}
                                menuPortalTarget={document.body}
                            />
                        </div>
                        <div className="form-column">
                            <label>Specific location<span>{!location.SpecificLocation && <span>(Optional)</span>}Dive site name or the best description</span></label>
                            <input 
                                type="text" 
                                name="specificLocation" 
                                value={data.specificLocation || ''} 
                                onChange={(e) => changeValue(e.target.name, e.target.value)} 
                                maxLength={70} 
                                className={`required ${location.SpecificLocation && errors.indexOf('specificLocation') > -1 ? 'error' : ''}`} 
                            />
                        </div>
                        <div className="form-column">
                            <label>Depth (ft)</label>
                            <input type="number" step="1" name="diveDepth"
                                disabled={data.location !== 1 && data.location !== 2 && location.Depth > 0 ? true : false}
                                value={data.location ? (data.location !== 1 && data.location !== 2 && location.Depth > 0 ? location.Depth : data.diveDepth) : 0}
                                maxLength="3"
                                onChange={(e) => changeValue(e.target.name, e.target.value)}
                                onKeyUp={(e) => {
                                    if (e.target.value.length > 2) decompressionRef.current.focus();
                                }}
                                onWheel={(e) => e.target.blur()}
                                className={`required ${errors.indexOf('diveDepth') > -1 ? 'error' : ''}`}
                                required={true} />
                        </div>
                        <div className="form-column">
                            <label>Decompression planning</label>
                            <Select ref={decompressionRef} className={`select required ${errors.indexOf('decompressionPlanning') > -1 ? 'error' : ''}`} required
                                options={info.decompression} 
                                onChange={(value) => changeSelectValue('decompressionPlanning', value, setDecompression)} 
                                styles={customStyles}  
                                value={decompression} 
                                menuPortalTarget={document.body}
                            />
                        </div>
                        <div className="form-column">
                            <label>Diving mode</label>
                            <Select className={`select required ${errors.indexOf('gear') > -1 ? 'error' : ''}`} required
                                options={info.gears}
                                onChange={(value) => changeSelectValue('gear', value, setGear)}
                                styles={customStyles}
                                value={gear}
                                //defaultValue={info.gears ? info.gears[15] : null}
                                menuPortalTarget={document.body}
                            />
                        </div>
                        <div className="form-column">
                            <label>Breathing gas</label>
                            <Select className={`select required ${errors.indexOf('gasMixture') > -1 ? 'error' : ''}`} required
                                options={info.gasMixtures}
                                onChange={(value) => changeSelectValue('gasMixture', value, setGasMixture)}
                                styles={customStyles}
                                value={gasMixture}
                                defaultValue={info.gasMixtures ? info.gasMixtures[0] : null}
                                menuPortalTarget={document.body}
                                />
                        </div>
                        <div className="form-column">
                            <label>Classification</label>
                            <div className={`radios blue required ${errors.indexOf('classificationId') > -1 ? 'error' : ''}`}>
                                {info.classifications ? <>
                                    {info.classifications.map(classification => (
                                        <div className="radio" key={classification['classificationId']}>
                                            <input type="radio" name="classificationId" 
                                                value={classification['classificationId'].toString()} 
                                                checked={parseInt(data.classificationId) === parseInt(classification['classificationId'])}
                                                id={`classification_${classification['classificationId']}`} 
                                                onChange={(e) => changeValue(e.target.name, e.target.value)}
                                                 />
                                            <label htmlFor={`classification_${classification['classificationId']}`}>
                                                {classification['classification']} <Help onClick={() => setClassification(classification)}  />
                                            </label>
                                        </div>
                                    ))}
                                </> : ''}
                            </div>
                        </div>
                        <div className="form-column">
                            <label>Tasks<span>(Optional)</span></label>
                            <div className="checkboxes blue">
                                {info.tasks ? <>
                                    {info.tasks.map(task => (
                                        <div className="checkbox" key={task['TaskID']}>
                                            <input type="checkbox" name="tasks" 
                                                value={task['TaskID'].toString()} 
                                                checked={taskValue.indexOf(task['TaskID'].toString()) > -1 ? true : false}
                                                id={`task_${task['TaskID']}`} 
                                                onChange={(e) => changeCheckboxValue(e.target.name, e.target.value, taskValue, setTaskValue)}
                                                 />
                                            <label htmlFor={`task_${task['TaskID']}`}>{task['Task']}</label>
                                        </div>
                                    ))}
                                </> : ''}
                            </div>
                        </div>
                        <div className="form-column">
                            <label>Specialized environment<span>(Optional)</span></label>
                            <div className="checkboxes blue">
                                {enviroments ? <>
                                    {enviroments.map(enviroment => (
                                        <div className="checkbox" key={enviroment}>
                                            <input type="checkbox" name="enviroments" 
                                                value={enviroment.replace(' ', '').replace('/', '')} 
                                                checked={enviromentValue.indexOf(enviroment.replace(' ', '').replace('/', '')) > -1 ? true : false}
                                                id={`enviroment_${enviroment}`}
                                                onChange={(e) => changeCheckboxValue(e.target.name, e.target.value, enviromentValue, setEnviromentValue)} />
                                            <label htmlFor={`enviroment_${enviroment}`}>{enviroment}</label>
                                        </div>
                                    ))}
                                </> : ''}
                            </div>
                        </div>
                        {modules.indexOf('Feedings') > -1 && data.location && isTaskInList('Feeding', data.tasks || []) && info.species.filter(item => item.LocationID === data.location) ? <>
                        <div className="form-control">
                            <label>Feeding details</label>
                            <div className="bordered-content" style={{maxWidth: '825px'}}>
                                <table>
                                    <thead>
                                        <tr>
                                            <th style={{width: '30%'}}>Species</th>
                                            <th style={{width: '35%'}}>Feeding results</th>
                                            <th style={{width: '35%'}}>Animal Engagement Level <Help onClick={() => setAggressionHelp(true)} /></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {info.species.filter(item => item.LocationID === data.location).map((species) => (
                                            <tr>
                                                <td>{species.Species}</td>
                                                <td>
                                                    <Select className="select" required 
                                                        options={feed[species.Individual]} 
                                                        onChange={(value) => changeFeedValue(value, species.SpeciesID)} 
                                                        styles={customStyles} 
                                                        value={data.species?.[species.SpeciesID] && data.species[species.SpeciesID].PercentFed > -1 ? feed[species.Individual].filter(item => item.value === data.species[species.SpeciesID].PercentFed) : feed[species.Individual][0]} 
                                                        defaultValue={feed[species.Individual][0]} 
                                                        menuPortalTarget={document.body}
                                                    />
                                                </td>
                                                <td>
                                                    <Select className="select" required 
                                                        options={egagementLevels} 
                                                        onChange={(value) => changeEngagementValue(value, species.SpeciesID)} 
                                                        styles={customStyles} 
                                                        value={data.species?.[species.SpeciesID] && data.species[species.SpeciesID].Aggression > -1 ? egagementLevels.filter(item => item.value === data.species[species.SpeciesID].Aggression) : egagementLevels[0]} 
                                                        defaultValue={egagementLevels[0]} 
                                                        menuPortalTarget={document.body}
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        </> : ''}
                        <div className="form-column">
                            <label>First buddy<span>(Optional)</span></label>
                            <div className="double">
                                <div className="form-control">
                                    <label>First name</label>
                                    <input type="text" name="buddyFirstName" value={data.buddyFirstName || ''} onChange={(e) => changeValue(e.target.name, e.target.value)} maxLength={20} />
                                </div>
                                <div className="form-control">
                                    <label>Last name</label>
                                    <input type="text" name="buddyLastName" value={data.buddyLastName || ''} onChange={(e) => changeValue(e.target.name, e.target.value)} maxLength={20} />
                                </div>
                            </div>
                        </div>
                        <div className="form-column">
                            <label>Second buddy<span>(Optional)</span></label>
                            <div className="double">
                                <div className="form-control">
                                    <label>First name</label>
                                    <input type="text" name="secondBuddyFirstName" value={data.secondBuddyFirstName || ''} onChange={(e) => changeValue(e.target.name, e.target.value)} maxLength={20} />
                                </div>
                                <div className="form-control">
                                    <label>Last name</label>
                                    <input type="text" name="secondBuddyLastName" value={data.secondBuddyLastName || ''} onChange={(e) => changeValue(e.target.name, e.target.value)} maxLength={20} />
                                </div>
                            </div>
                        </div>
                        <div className="form-column">
                            <label>Surface conditions<span>(Optional)</span></label>
                            <Select className="select" required 
                                options={info.surfaceConditions} 
                                onChange={(value) => changeSelectValue('surfaceCondition', value, setSurfaceCondition)} 
                                styles={customStyles} 
                                value={surfaceCondition}
                                menuPortalTarget={document.body} />
                        </div>
                        <div className="form-column">
                            <label>Underwater conditions<span>(Optional)</span></label>
                            <Select className="select" required 
                                options={info.underwaterConditions} 
                                onChange={(value) => changeSelectValue('underwaterCondition', value, setUnderwaterCondition)} 
                                styles={customStyles} 
                                value={underwaterCondition}
                                menuPortalTarget={document.body} />
                        </div>
                        {modules.indexOf('Dive incidents') > -1 && isTaskInList('Presenter', data.tasks || []) ? <>
                            <div className="form-column">
                                <label>Mask #/Comm #</label>
                                <input type="text" name="CommMask" value={data.CommMask || ''} onChange={(e) => changeValue(e.target.name, e.target.value)} maxLength={50} />
                            </div>
                            <div className="form-column">
                                <label>Comms Problems During Presentation</label>
                                <div className="radios blue">
                                    <div className="radio" key="no-problems">
                                        <input type="radio" name="CommProblemsSwitcher" 
                                            value={0}
                                            checked={!data.CommProblemsSwitcher}
                                            id={`problems_no-problems`} 
                                            onChange={(e) => changeValue(e.target.name, parseInt(e.target.value))}
                                        />
                                        <label htmlFor={`problems_no-problems`}>
                                            No comms problems - presentation went smoothly
                                        </label>
                                    </div>
                                    <div className="radio" key="problems">
                                        <input type="radio" name="CommProblemsSwitcher" 
                                            value={1}
                                            checked={data.CommProblemsSwitcher}
                                            id={`problems_problems`} 
                                            onChange={(e) => changeValue(e.target.name, parseInt(e.target.value))}
                                        />
                                        <label htmlFor={`problems_problems`}>
                                            Some comms problems (check all that apply):
                                        </label>
                                    </div>
                                    {data.CommProblemsSwitcher ? <>
                                        <div className={`checkboxes blue required ${errors.indexOf('presentationProblems') > -1 ? 'error' : ''}`}>
                                            {info.presentationProblems ? <>
                                                {info.presentationProblems.map(problem => (
                                                    <div className="checkbox shift" key={problem['id']}>
                                                        <input type="checkbox" name="presentationProblems" 
                                                            value={problem['id'].toString()} 
                                                            checked={presentationProblemsValue.indexOf(problem['id'].toString()) > -1 ? true : false}
                                                            id={`presentationProblems_${problem['id']}`} 
                                                            onChange={(e) => changeCheckboxValue(e.target.name, e.target.value, presentationProblemsValue, setPresentationProblemsValue)}
                                                            />
                                                        <label htmlFor={`presentationProblems_${problem['id']}`}>{problem['problem']}</label>
                                                    </div>
                                                ))}
                                            </> : ''}
                                        </div> 
                                        <div className="form-control shift">
                                            <label>Other (specify)</label>
                                            <textarea name="CommProblems" value={data.CommProblems || ''} onChange={(e) => changeValue(e.target.name, e.target.value)} />
                                        </div>
                                    </> : ''}
                                </div>
                            </div>
                        </> : ''}
                        {modules.indexOf('Dive Briefing') > -1 ?
                        <div className="form-column">
                            <label>Dive Briefing conducted by<span>(Optional)</span></label>
                            <input type="text" name="DiveBriefingBy" value={data.DiveBriefingBy || ''} onChange={(e) => changeValue(e.target.name, e.target.value)} maxLength={50} />
                        </div> : ''}
                        <div className="form-column">
                            <label>Comments<span>(Optional)</span></label>
                            <textarea name="comments" value={data.comments || ''} onChange={(e) => changeValue(e.target.name, e.target.value)} />
                        </div>
                        {modules.indexOf('Animal & Equipment Observations') > -1 ?
                        <div className="form-column">
                            <label>Animal & Equipment Observations<span>(Optional, instantly notifies husbandry staff)</span></label>
                            <textarea name="AnimalObservations" value={data.AnimalObservations || ''} onChange={(e) => changeValue(e.target.name, e.target.value)} />
                        </div> : ''}
                        <div className="form-submit">
                            <div><button type="submit" className="primary">{loading ? <Loading className="btn-loader" alt="loader" /> : ''}Send</button></div>
                            {error ? <div className="error">{error}</div> : ''}
                            {success ? <div className="success">Dive log was successfully {params.diveId ? 'updated' : 'added'}</div> : ''}
                            {error && existing ? <div className="bordered-content">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th>Starting Time</th>
                                            <th>OM</th>
                                            <th>Duration (min)</th>
                                            <th>Location</th>
                                            <th>Gear</th>
                                            <th>Depth (ft)</th>
                                            <th>Comments</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{existing.OMID === orgId ? <Link to={`/logs/edit/${existing.DiveID}`} target="_blank">{existing.date}<span className="mobile">{is24h > 0 ? existing.time24 : existing.time12}</span></Link> : <>{existing.date}<span className="mobile">{is24h > 0 ? existing.time24 : existing.time12}</span></>}</td>
                                            <td className="desktop">{is24h > 0 ? existing.time24 : existing.time12}</td>
                                            <td><strong className="mobile">OM: </strong><a href={`https://${existing.AAUSURL}`} target="_blank" rel="noreferrer">{existing.Name}</a></td>
                                            <td><strong className="mobile">Duration: </strong>{existing.TotalTimeOfDive}<span className="mobile">min</span></td>
                                            <td><strong className="mobile">Location: </strong>{existing.Location}</td>
                                            <td><strong className="mobile">Gear: </strong>{existing.Gear}</td>
                                            <td><strong className="mobile">Depth: </strong>{existing.DiveDepth || 'n/a'}<span className="mobile">ft</span></td>
                                            <td><strong className="mobile">Comments: </strong>{existing.Comments}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                {existing.OMID === orgId ? <div>
                                    <p>If the actual problem is with the previously entered dive(s), please click on the date on the date above . It will open that dive in another window for editing. After you are done editing the previous dive, close the window and return to this screen.</p>
                                </div> : ''}
                            </div>: ''}
                        </div>
                    </form>
                </>
            }
            {classification ? <ModalDescription setClose={() => setClassification(null)} classification={classification}  /> : ''}
            {aggressionHelp ? <ModalEngagement setClose={() => setAggressionHelp(null)} /> : ''}
        </>
    );
};

export default Log;

const ModalDescription = ({setClose, classification}) => {
    return (
        <Modal setClose={setClose} icon={<Info />}>
             <h2>{classification.classification}</h2>
             <p>{classification.Description}</p>
        </Modal>
     )
 }

const ModalEngagement = ({setClose}) => {
    return (
        <Modal setClose={setClose} icon={<Info />} type="wide">
            <h2>Engagement levels</h2>
            <p>Not observed by me = not your target animal</p>
            <p><strong>0 – None</strong> = Did not engage/participate in session</p>
            <p><strong>1 – Poor</strong> = Animal had a flee reaction or retreated from session when divers descended.</p>
            <p><strong>2 – Fair</strong> = Animal approached station slowly or initially stationed at incorrect location. Needed to be coaxed/lured to correct location. Animal engaged for &lt;1/2 of session. Left on own accord.</p>
            <p><strong>3 – Good</strong> = Animal approached station or initially stationed at incorrect location but adjusted on its own. Animal engaged for ~1/2 of session. Left on own accord.</p>
            <p><strong>4 – Great</strong> = Animal approached correct station quickly. Animal was engaged for &gt;1/2 of session. Left on own accord.</p>
            <p><strong>5 – Excellent</strong> = Animal approached station quickly. Animal was engaged for entire session. Couldn't have asked for a better feed! </p>
        </Modal>
     )
 }